/* eslint react/no-danger: 0 */
import React from 'react';
import PropTypes from 'prop-types';

const SireReference = ({ data: { sireReference } }) => (sireReference ? (
    <section
        className="hp-weatherbys hp-weatherbys__sireReference"
        dangerouslySetInnerHTML={{ __html: sireReference }}
    />
) : null);

SireReference.propTypes = {
    data: PropTypes.shape({
        sireReference: PropTypes.string,
    }),
};

export default SireReference;



// WEBPACK FOOTER //
// ./src/js/horse/sireReference/SireReference.jsx